import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useProgramCache } from './cache'
import { toResponseError, type ProgramAddInput, type ProgramAddSuccess, type ProgramData } from '@terros/common'

export function useAddProgram(): AddHookResponse<ProgramAddInput, ProgramData> {
  const mutation = useTantalimMutation<ProgramAddInput, ProgramAddSuccess>({
    url: '/program/add',
  })
  const cache = useProgramCache()

  async function add(program: ProgramAddInput): Promise<ProgramData> {
    try {
      const { program: newProgram } = await mutation.mutateAsync(program)
      cache.addItem(newProgram)
      return newProgram
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
